import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    appSettingName: String,
    open: Boolean,
    url: String,
    minimizeText: String,
    maximizeText: String,
    minimizeSvgTitle: String,
    maximizeSvgTitle: String,
  }

  connect() {
    if (!this.openValue) {
      this.element.classList.add('minimizable--minimized')
    }
    this.#updateButtonText(this.openValue)
  }

  toggle() {
    const newValue = !this.openValue
    this.openValue = newValue

    this.element.classList.toggle('minimizable--minimized', !newValue)
    this.#updateButtonText(newValue)

    const formData = new FormData()
    formData.append(`app_settings[${this.appSettingNameValue}]`, newValue)

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      },
      body: formData,
    })
  }

  #updateButtonText(isOpen) {
    const buttonText = this.element.querySelector('.minimizable__button-text')
    if (buttonText) {
      buttonText.textContent = isOpen ? this.minimizeTextValue : this.maximizeTextValue
    }
    const svgTitle = this.element.querySelector('.minimizable__icon title')
    if (svgTitle) {
      svgTitle.textContent = isOpen ? this.minimizeSvgTitleValue : this.maximizeSvgTitleValue
    }
  }
}
